import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the datatable for withdrawal requests.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                { id: 'Date', header: _('Fecha'), width: 100, sort: 'int' },
                { id: 'User', header: _('Usuario'), width: 100, sort: 'int' },
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 150,
                    sort: 'int',
                },
                { id: 'Token', header: _('Código'), width: 100, sort: 'int' },
            ],
            editable: true,
            math: true,
            loadahead: devConfig.getDefaultDataFetch(),
            pager: 'pagerA',
            url: devConfig.geturlApi() + '/UserManagement/GetUserSecurityL',
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true);
        var url = grid.data.url;

        // Event listener for generating token with filters
        this.on(this.app, 'generateToken:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'FromDateLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'ToDateLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&UserId=' + cur_user;
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id);
            this.$scope.app.callEvent('user:id', [item.Id]);
        });

        // Event listener for before edit start
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id);
            console.log(item);
            if (id.column == 'State') {
                var options = this.getColumnConfig('Action').collection;
                if (item.State == 'A') {
                    options.remove('A');
                } else if (item.State == 'I') {
                    options.remove('I');
                } else {
                    return false;
                }
                console.log(id);
            }
        });

        // Event listener for after edit stop
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row);
            console.log(item);
            if (state.value != state.old) {
                if (state.value == 'A') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! ');
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'P';
                                webix.message('Cell value was changed');
                            },
                        });
                }
                if (state.value == 'P') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! ');
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'I';
                                webix.message('Cell value was changed');
                            },
                        });
                }
                if (state.value == 'E') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! ');
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'E';
                                webix.message('Cell value was changed');
                            },
                        });
                }
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id);
        });
    }
}

// FILE DOCUMENTED
